import TrendChart from './TrendChart';

export default TrendChart;
